import 'react-responsive-carousel/lib/styles/carousel.min.css'

import { debounce } from 'lodash'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import ym from 'react-yandex-metrika'
import { Navigation } from 'swiper'
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react'

import { baseURLImage } from '../../../api/api'
import { isMobile } from '../../../helpers/isMobile'
import { getProject } from '../../../store/project/project'
import styles from './projectFeatures.module.scss'
import { IProjectFeaturesProps } from './ProjectFeatures.types'

export const ProjectFeatures = ({
  carouselCards,
  title = 'Особенности проекта',
  banner = true,
  projectName,
}: IProjectFeaturesProps) => {
  const sliderRef = useRef<SwiperRef | null>(null)
  const [firstSlide, setFirstSlide] = useState(true)
  const [lastSlide, setLastSlide] = useState(false)
  const [initSlider, setInitSlider] = useState(false)
  const { project } = useSelector(getProject)

  const setButtonState = () => {
    if (!sliderRef.current) return

    setFirstSlide(sliderRef.current.swiper.isBeginning)
    setLastSlide(sliderRef.current.swiper.isEnd)
  }

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return
    sliderRef.current.swiper.slidePrev()
    setButtonState()
  }, [])

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return
    sliderRef.current.swiper.slideNext()
    setButtonState()
  }, [])

  const setStateSlider = debounce(() => {
    if ((isMobile() && carouselCards.length > 1) || carouselCards.length > 3) {
      if (!initSlider) {
        setInitSlider(true)
      }
    } else {
      if (initSlider) {
        setInitSlider(false)
      }
    }
  }, 500)

  useEffect(() => {
    setStateSlider()

    window.addEventListener('resize', setStateSlider)
    return () => {
      window.removeEventListener('resize', setStateSlider)
    }
  }, [])

  useEffect(() => {
    if (sliderRef.current) sliderRef.current.swiper.slideTo(0)
  }, [carouselCards])

  return (
    <div className={styles.featureWrapper}>
      <h2 className={styles.featureTitle}>{title}</h2>
      <Swiper
        ref={sliderRef}
        className={styles.featureSlider}
        modules={[Navigation]}
        speed={500}
        slidesPerView={1}
        slidesPerGroup={1}
        spaceBetween={10}
        breakpoints={{
          1376: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 2.36,
            slidesPerGroup: 3,
            spaceBetween: 34,
          },
        }}
        onSlideChange={() => {
          setButtonState()
        }}
      >
        {carouselCards.map((card, index) => (
          <SwiperSlide className={styles.featureSlider__slide} key={index}>
            <img src={`${baseURLImage}${card.SRC}`} alt='' />
            <p className={styles.carouselCardDescription}>{card.DESCRIPTION}</p>
          </SwiperSlide>
        ))}
      </Swiper>
      {initSlider && (
        <div className={styles.featureSlider__controls}>
          <button
            disabled={firstSlide ?? true}
            className={`${styles.featureSlider__control} ${styles['featureSlider__control--prev']}`}
            onClick={handlePrev}
          />
          <button
            disabled={lastSlide ?? true}
            className={`${styles.featureSlider__control} ${styles['featureSlider__control--next']}`}
            onClick={handleNext}
          />
        </div>
      )}

      {banner && project && (
        <a
          className={styles.pikBunner}
          href={
            project?.projectUrl && project?.projectUrl.includes('borisenko')
              ? 'https://www.pik.ru/vladivostok/mortgage?utm_source=rbc&utm_medium=display&utm_content=mortgage'
              : 'https://www.pik.ru/pages/social?utm_source=rbc&utm_medium=display&utm_content=project'
          }
          target='_blank'
          onClick={() => {
            ym('reachGoal', 'client link', {
              'client link': {
                'project page': {
                  'PIK Social': projectName,
                },
              },
            })
          }}
        >
          {project?.projectUrl && project?.projectUrl.includes('borisenko') ? (
            <p>Дальневосточная ипотека</p>
          ) : (
            <p>ПИК строит социальную инфраструктуру</p>
          )}
        </a>
      )}
    </div>
  )
}
